import type { ParentDuty } from '../models/parent-duty.model';

export interface DutyRoutineProgress {
  routineName: string;
  completedCount: number;
  totalCount: number;
}

/** Groups ritual duties for board labels ("Evening ritual · 2/4"). */
export function routineGroupKey(duty: ParentDuty): string | null {
  if (!duty.routineName?.trim()) {
    return null;
  }
  if (duty.sourceTemplateId && duty.instancePeriodKey) {
    return `${duty.sourceTemplateId}:${duty.reciever}:${duty.instancePeriodKey}`;
  }
  if (duty.templateApplyBatchId) {
    return duty.templateApplyBatchId;
  }
  return null;
}

export function buildRoutineProgressByDutyId(
  duties: ParentDuty[],
): Map<string, DutyRoutineProgress> {
  const membersByKey = new Map<string, ParentDuty[]>();

  for (const duty of duties) {
    const key = routineGroupKey(duty);
    if (!key) continue;
    const members = membersByKey.get(key) ?? [];
    members.push(duty);
    membersByKey.set(key, members);
  }

  const progressByDutyId = new Map<string, DutyRoutineProgress>();

  for (const members of membersByKey.values()) {
    if (members.length < 2) continue;

    const routineName = members[0]?.routineName?.trim();
    if (!routineName) continue;

    const completedCount = members.filter((d) => d.completed).length;
    const progress: DutyRoutineProgress = {
      routineName,
      completedCount,
      totalCount: members.length,
    };

    for (const duty of members) {
      if (duty.id) {
        progressByDutyId.set(duty.id, progress);
      }
    }
  }

  return progressByDutyId;
}
